import React, { useEffect, useState } from "react";
import "./Settlements.css";
import { getSettlementAmount } from "../../config/LiveApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DateFilter from "../../components/common/DateFilter";
import DataTable from "../../components/common/DataTable/DataTable";
import Spinner from "../Spin/Spinner";

const GetSettlements = () => {
  const token = useSelector((store) => store.userReducer.token);

  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchSettlementData = async (start, end) => {
    setIsLoading(true);
    try {
      const response = await getSettlementAmount(start, end);
      setTableData(response || []);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchSettlementData(startDate, endDate);
    }
  }, [token, startDate, endDate]);

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  const formatAmount = (value) => `₹ ${Number(value || 0).toFixed(2)}`;

  const columns = [
    {
      key: "providerName",
      header: "Provider Name",
    },
    {
      key: "orgName",
      header: "Organization Name",
    },
    {
      key: "totalSettlement",
      header: "Total Settlement Amount",
      render: (row) => formatAmount(row.transactions?.[0]?.total_transactions),
    },
    {
      key: "12am5am",
      header: "12AM - 5AM (INR)",
      render: (row) => formatAmount(row.transactions?.[0]?.["12am - 5am"]),
    },
    {
      key: "5am7am",
      header: "5AM - 7AM (INR)",
      render: (row) => formatAmount(row.transactions?.[0]?.["5am - 7am"]),
    },
    {
      key: "7am1pm",
      header: "7AM - 1PM (INR)",
      render: (row) => formatAmount(row.transactions?.[0]?.["7am - 1pm"]),
    },
    {
      key: "1pm7pm",
      header: "1PM - 7PM (INR)",
      render: (row) => formatAmount(row.transactions?.[0]?.["1pm - 7pm"]),
    },
    {
      key: "7pm12am",
      header: "7PM - 12AM (INR)",
      render: (row) => formatAmount(row.transactions?.[0]?.["7pm - 12am"]),
    },
  ];

  return (
    <div className="settlement-table-container">
      <div className="analytics-header">
        <h2 className="settlement-table-title">Provider Settlement</h2>
      </div>

      {/* DATE FILTER */}
      <DateFilter onDateChange={handleDateChange} />

      {isLoading ? (
        <Spinner />
      ) : (
        <DataTable
          columns={columns}
          data={tableData}
          loading={isLoading}
          emptyMessage="No Data Found"
        />
      )}
    </div>
  );
};

export default GetSettlements;
